<template>
  <div
    v-if="memorialHallModel"
    class="worshipPage"
    :style="'height:' + fullHeight + 'px;'"
  >
    <!-- header start -->
    <van-nav-bar
      :title="memorialHallModel.MemorialHallSearchApiModel.Title + '墓园'"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <template #right>
        <van-icon name="share" @click="shareHandler" />
      </template>
    </van-nav-bar>
    <!-- header end -->
    <!-- 背景图 -->
    <img
      v-if="memorialHallModel"
      :src="memorialHallModel.Template.ImagePath"
      class="worshipBg"
    />
    <img v-else src="@/assets/images/worship/bg01.jpg" class="worshipBg" />
    <!-- <img src="@/assets/images/worship/muyuan_bg.jpg" class="worshipBg" /> -->

    <section class="left-cate-box" v-if="memorialHallModel">
      <div
        id="desc"
        style="display: none"
        v-html="
          memorialHallModel.MemorialHallSearchApiModel
            .DeceasedInformationApiModelList[0].LifeIntroduction
        "
      ></div>
      <router-link
        :to="{
          path: '/GiftRecord',
          query: {
            id: mid,
            uid: muid,
            placeType: placeType,
            KeyName: 'Tribute',
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_xiang.png" class="icon" />
        <span class="num">{{ memorialHallModel.TributeTotalCount }}</span>
      </router-link>
      <router-link
        :to="{
          path: '/GiftRecord',
          query: {
            id: mid,
            uid: muid,
            placeType: placeType,
            KeyName: 'Homa',
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_hua.png" class="icon" />
        <span class="num">{{ memorialHallModel.HomaTotalCount }}</span>
      </router-link>
      <router-link
        :to="{
          path: '/GiftRecord',
          query: {
            id: mid,
            uid: muid,
            placeType: placeType,
            KeyName: 'Salute',
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_huo.png" class="icon" />
        <span class="num">{{ memorialHallModel.SaluteTotalCount }}</span>
      </router-link>
    </section>
    <section class="right-cate-box">
      <router-link
        v-if="
          memorialHallModel &&
          currentToken.isLogin &&
          memorialHallModel.MemorialHallSearchApiModel.MemberId ==
            currentToken.memberID
        "
        :to="{
          path: '/TemplateList',
          query: {
            id: this.mid,
            keyName: 'CemeteryTemplate',
            mid: memorialHallModel.MemorialHallSearchApiModel.MemorialHallID,
            placeType: placeType,
            templateid:
              memorialHallModel.MemorialHallSearchApiModel
                .MemorialHallAppBuyCemeteryTemplateId,
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_muban.png" class="icon" />
        <span class="num">模板</span>
      </router-link>
      <router-link
        :to="{
          path: '/GiftRecord',
          query: {
            id: mid,
            uid: muid,
            placeType: placeType,
            KeyName: 'Blessing',
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_gongpin.png" class="icon" />
        <span class="num">{{ memorialHallModel.BlessingTotalCount }}</span>
      </router-link>
      <router-link
        :to="{
          path: '/GiftRecord',
          query: {
            id: mid,
            uid: muid,
            placeType: placeType,
            KeyName: 'CemeteryPackage',
          },
        }"
        class="cate-item"
      >
        <img src="@/assets/images/worship/icon_lazhu.png" class="icon" />
        <span class="num">{{ memorialHallModel.PackageTotalCount }}</span>
      </router-link>
    </section>

    <section
      class="gift-section"
      :style="{
        backgroundImage: `url('${memorialHallModel.Template.TombstoneImagePath}')`,
      }"
    >
      <div class="box">
        <!-- 双人头像 -->
        <section
          class="touxiang-double"
          v-if="
            memorialHallModel &&
            memorialHallModel.MemorialHallSearchApiModel
              .DeceasedInformationApiModelList.length > 1
          "
        >
          <div
            class="item"
            v-for="item in memorialHallModel.MemorialHallSearchApiModel
              .DeceasedInformationApiModelList"
            :key="item.Id"
          >
            <div class="avatar">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item.HeadPhoto"
              />
            </div>
            <P class="name">{{ item.DeceasedName }}</P>
            <P class="date">
              {{
                item.OutPutBirthdayDateDesc.length > 4
                  ? item.OutPutBirthdayDateDesc.substring(0, 4)
                  : item.OutPutBirthdayDateDesc
              }}
              -
              {{
                item.OutPutPassAwayDateDesc.length > 4
                  ? item.OutPutPassAwayDateDesc.substring(0, 4)
                  : item.OutPutPassAwayDateDesc
              }}
            </P>
          </div>
        </section>
        <!-- 单人头像 -->
        <section class="touxiang-single" v-else-if="memorialHallModel">
          <div class="avatar">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="
                memorialHallModel.MemorialHallSearchApiModel
                  .DeceasedInformationApiModelList[0].HeadPhoto
              "
            />
          </div>
          <P class="name">{{
            memorialHallModel.MemorialHallSearchApiModel
              .DeceasedInformationApiModelList[0].DeceasedName
          }}</P>
          <P class="date">
            {{
              memorialHallModel.MemorialHallSearchApiModel
                .DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc
                .length > 4
                ? memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc.substring(
                    0,
                    4
                  )
                : memorialHallModel.MemorialHallSearchApiModel
                    .DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc
            }}
            -
            {{
              memorialHallModel.MemorialHallSearchApiModel
                .DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc
                .length > 4
                ? memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc.substring(
                    0,
                    4
                  )
                : memorialHallModel.MemorialHallSearchApiModel
                    .DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc
            }}
          </P>
        </section>
        <div
          v-if="memorialHallModel && memorialHallModel.SacrificeLogPackageModel"
        >
          <div class="first-floor">
            <div class="first-floor-content">
              <!-- 烧香 -->
              <router-link
                to="#"
                v-if="memorialHallModel.SacrificeLogIncensePackage"
                class="xianghuo"
              >
                <div class="stack">
                  <img
                    src="@/assets/images/worship/jp_xianglu.png"
                    class="lu"
                  />
                  <div
                    v-if="
                      memorialHallModel.SacrificeLogIncensePackage
                        .SerialNumber > 0
                    "
                  >
                    <img
                      v-if="
                        memorialHallModel.SacrificeLogIncensePackage
                          .SacrificePath != ''
                      "
                      :src="
                        memorialHallModel.SacrificeLogIncensePackage
                          .SacrificePath
                      "
                      class="xiang"
                    />
                  </div>
                </div>
                <!-- 左右蜡烛 -->
              </router-link>
              <div v-if="memorialHallModel.SacrificeLogWaxIncensePackage">
                <router-link
                  :to="{
                    path: '/GiftDetails',
                    query: {
                      id:
                        memorialHallModel.SacrificeLogWaxIncensePackage
                          .SerialNumber,
                    },
                  }"
                  class="lazhu-left lazhu"
                >
                  <img
                    :src="
                      memorialHallModel.SacrificeLogWaxIncensePackage
                        .SacrificePath
                    "
                    class
                  />
                </router-link>
                <router-link
                  :to="{
                    path: '/GiftDetails',
                    query: {
                      id:
                        memorialHallModel.SacrificeLogWaxIncensePackage
                          .SerialNumber,
                    },
                  }"
                  class="lazhu-right lazhu"
                >
                  <img
                    :src="
                      memorialHallModel.SacrificeLogWaxIncensePackage
                        .SacrificePath
                    "
                    class
                  />
                </router-link>
              </div>
              <div v-if="memorialHallModel.SacrificeLogBurnPaperIncensePackage" >
                
                <div class="fire-left" >
                <img
                   :src="memorialHallModel.SacrificeLogBurnPaperIncensePackage
                        .SacrificePath"
                  />
              </div>
              <div class="fire-right" >
                <img
                :src="memorialHallModel.SacrificeLogBurnPaperIncensePackage
                        .SacrificePath"
                  />
              </div>
              </div>
            </div>
          </div>
          <!-- 套餐 -->
          <div
            class="packgage-floor"
            v-if="memorialHallModel.SacrificeLogPackageModel.AppSacrifice"
          >
            <img
              :src="
                memorialHallModel.SacrificeLogPackageModel.AppSacrifice
                  .SacrificePath
              "
              class
            />
          </div>
        </div>
        <div class="first-floor" v-else>
          <div class="first-floor-content">
            <!-- 烧香 -->
            <div class="xianghuo">
              <div class="stack">
                <img src="@/assets/images/worship/jp_xianglu.png" class="lu" />
                <router-link
                  v-if="incenseLogId > 0"
                  :to="{ path: '/GiftDetails', query: { id: incenseLogId } }"
                >
                  <img :src="incensePic" class="xiang" />
                </router-link>
              </div>
            </div>
            <div
              v-for="(
                item, index
              ) in memorialHallModel.SacrificeLogWaxIncenseList"
              :key="index"
            >
              <router-link
                :to="{ path: '/GiftDetails', query: { id: item.SerialNumber } }"
                class="lazhu-left lazhu"
              >
                <img :src="item.AppSacrifice.SacrificePath" class />
              </router-link>
              <router-link
                :to="{ path: '/GiftDetails', query: { id: item.SerialNumber } }"
                class="lazhu-right lazhu"
              >
                <img :src="item.AppSacrifice.SacrificePath" class />
              </router-link>
            </div>
            <!-- 左右鲜花 -->
            <!-- <router-link to="/GiftDetails" class="hua hua-left">
              <img src="http://img2.huaien.com/jinian/material/j03/j03_t_04.png" class />
            </router-link>
            <router-link to="/GiftDetails" class="hua hua-right">
              <img src="http://img2.huaien.com/jinian/material/j03/j03_t_04.png" class />
            </router-link>-->
          </div>
        </div>
        <!-- 祭品 -->
        <div
          class="gift-floor"
          v-if="
            memorialHallModel.SacrificeLogPendulumList &&
            memorialHallModel.SacrificeLogPendulumList.length > 0 &&
            memorialHallModel.SacrificeLogPackageModel == null
          "
        >
          <div
            v-for="(item, index) in memorialHallModel.SacrificeLogPendulumList"
            :key="index"
          >
            <router-link
              :to="{ path: '/GiftDetails', query: { id: item.SerialNumber } }"
            >
              <img :src="item.AppSacrifice.SacrificePath" class />
            </router-link>
          </div>
        </div>
 
        <!-- <div class="gift-floor">
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j04/j04_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j05/j05_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j05/j05_t_06.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_04.png" class=""></router-link>
      <router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j04/j04_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j05/j05_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j05/j05_t_06.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_04.png" class=""></router-link>
      <router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_01.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j05/j05_t_06.png" class=""></router-link>
			<router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j06/j06_t_04.png" class=""></router-link>
      <router-link to="/GiftDetails"><img src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png" class=""></router-link>
        </div> -->
      </div>
    </section>

    <section class="tabBarBottmon">
      <router-link
        :to="{ path: '/Life', query: { id: mid } }"
        class="item"
        @click="shareHandler"
      >
        <img src="@/assets/images/worship/btm_icon01.png" class="icon" />
        <span class="text">生平</span>
      </router-link>
      <router-link
        :to="{ path: '/Photos', query: { id: mid } }"
        class="item"
        @click="shareHandler"
      >
        <img src="@/assets/images/worship/btm_icon02.png" class="icon" />
        <span class="text">影像</span>
      </router-link>
      <div class="item" style="visibility: hidden">
        <span class="text">祭拜</span>
      </div>
      <router-link
        :to="{ path: '/Memory', query: { id: mid } }"
        class="item"
        @click="shareHandler"
      >
        <img src="@/assets/images/worship/btm_icon03.png" class="icon" />
        <span class="text">追忆</span>
      </router-link>
      <router-link
        :to="{ path: '/Mailbox', query: { id: mid } }"
        class="item"
        @click="shareHandler"
      >
        <img src="@/assets/images/worship/btm_icon04.png" class="icon" />
        <span class="text">信箱</span>
      </router-link>
      <router-link :to="{ path: '/GiftList', query: { id: mid }}" class="jibaiBtn">
        <img src="@/assets/images/worship/worship_btn.png" class="icon" />
      </router-link>
    </section>
    <!--礼物点击弹出效果-->
    <img
      :src="showimg"
      class="movegift"
      :class="isMovegift ? 'fade-enter-active' : ''"
    />

    <transition name="fade">
      <img :src="showimg" class="movegift_lb" v-if="isMovegift_lb" />
    </transition>
  </div>
</template>

<script>
import soshm from "soshm";
import placeTypeStatus from "@/static/sacrificePlaceTypeStatus";
import { mapGetters } from "vuex";
import { Toast } from "vant";
import auth from '../../../tools/auth';

export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      showNumber: 1,
      mid: 0,
      muid: "",
      placeType: 0,
      memorialHallModel: null,
      incensePic: "",
      incenseLogId: 0,
      isMovegift: false,
      isMovegift_lb: false,
      showimg: "",
    };
  },
  computed: {
    ...mapGetters(["currentToken"]),
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    this.get_bodyHeight();
     this.timer = setTimeout(this.get, 5000);
  },
  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    get() {
      this.isMovegift = false;
      this.isMovegift_lb = false;
    },
    onClickLeft() {
      // this.$router.go(-1);
      this.$back();
    },
    /**推荐给朋友**/
    shareHandler() {
      // soshm.popIn({
      //   title: "弹窗分享",
      //   sites: ["weixin", "weixintimeline", "weibo", "qzone", "tqq", "qq"]
      // });
      if (this.$weixin.IsWeiXin()) {
        soshm.weixinSharetip();
      } else {
        Toast("当前暂不支持分享");
      }
    },
    init() {
      var that = this;
      this.$store.commit("setPlaceType", this.placeType);
      this.getData();
    },
    getData() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMourningHallMourningHallSearch",
          Id: that.mid,
          PlaceType: that.placeType,
        })
        .then(
          (res) => {
            that.memorialHallModel = res;

            if (res.MemorialHallSearchApiModel.IsPrivacy) {
              var _id=res.MemorialHallSearchApiModel.SerialNumber;
              auth.IsFriend(this,_id);
            }

            if (
              res.SacrificeLogIncenseList &&
              res.SacrificeLogIncenseList.length > 0
            ) {
              res.SacrificeLogIncenseList.map((e) => {
                that.incensePic = e.AppSacrifice.SacrificePath;
                that.incenseLogId = e.SerialNumber;
              });
            }
            if (that.$weixin.IsWeiXin()) {
              that.initweixinShare();
            }
          },
          (err) => {}
        );
    },
    getShowImg() {
      var that = this;
      var sacrifice = this.$store.state.sacrificemodel;
      if (sacrifice != null) {
        // that.showimg = sacrifice.CoverPhotoPath;
        that.showimg = sacrifice.SacrificePath;
        if (sacrifice.AppSacrificeTypeId == 10) {
          //行礼
          this.isMovegift_lb = true;
        } else {
          that.isMovegift = true;
        }
        that.$store.commit("delSacrifice");
      }
    },
    initweixinShare() {
      var that = this;
      this.$nextTick(() => {
        let desc = document.querySelector("#desc").innerText;
        if (!desc) {
          desc = that.memorialHallModel.MemorialHallSearchApiModel.Title;
        }
        that.$weixin.ShareWeiXinAppMessage(
          that.memorialHallModel.MemorialHallSearchApiModel.Title,
          desc,
          that.memorialHallModel.MemorialHallSearchApiModel
            .DeceasedInformationApiModelList[0].HeadPhoto,
          "MemorialHall?id=" +
            that.memorialHallModel.MemorialHallSearchApiModel.SerialNumber
        );
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "GiftList") {
      from.meta.refresh = true;
    }
    next();
  },
  created() {
    //console.log(this.$store.state.mid,"mid");
    var that = this;
    var _id = this.$route.query.id;
    if(_id!=null){
      this.mid=_id;
    }else{
      this.mid = this.$store.state.mid;
    }
    this.muid = this.$store.state.muid;
    this.placeType = placeTypeStatus.Cemetery;
    this.init();
    this.getShowImg();
  },
};
</script>

<style scoped>
.worshipPage {
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: #000;
}
.worshipBg {
  position: absolute;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.mynavbar {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.left-cate-box {
  position: absolute;
  left: 8px;
  top: 66px;
  z-index: 9;
}
.right-cate-box {
  position: absolute;
  right: 8px;
  top: 66px;
  z-index: 9;
}
.cate-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  margin-bottom: 10px;
  width: 50px;
  height: 50px;
}
.cate-item > .icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.cate-item > .num {
  font-size: 10px;
  color: yellow;
}
.touxiang-single {
  position: relative;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.touxiang-single .avatar {
  width: 30px;
  height: 42px;
}
.touxiang-single .name {
  font-size: 12px;
  color: orange;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 8px;
}
.touxiang-single .date {
  font-size: 12px;
  color: orange;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.6);
}
.touxiang-double {
  position: relative;
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.touxiang-double .item {
  position: relative;
  width: 34px;
  margin: 0 1px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.touxiang-double .item .avatar {
  width: 25px;
  height: 36px;
}
.touxiang-double .item .name {
  font-size: 12px;
  color: orange;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.5);
}
.touxiang-double .item .date {
  font-size: 10px;
  color: orange;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.4);
}
.gift-section {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 368px;
  background: center center no-repeat;
  background-size: 100% 100%;
}
/* background: url({{memorialHallModel.Template.TombstoneImagePath}}) center center no-repeat; */
/* "~@/assets/images/worship/mubei.png" */
.gift-section > .box {
  position: relative;
  width: 100%;
  height: 100%;
}
.first-floor {
  position: absolute;
  bottom: 230px;
  left: 0;
  right: 0;
  width: 100%;
  height: 203px;
}
.first-floor-content {
  position: relative;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
}
.xianghuo {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack {
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack .lu {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 41px;
  height: auto;
  margin: auto;
  z-index: 10;
}
.xianghuo .stack .xiang {
  position: absolute;
  bottom: 21px;
  left: 0;
  right: 0;
  max-width: 41px;
  max-height: 60px;
  margin: auto;
  z-index: 9;
}
.lazhu-left {
  position: absolute;
  bottom: 0;
  left: 32%;
}
.lazhu-right {
  position: absolute;
  bottom: 0;
  right: 32%;
}
.lazhu {
  max-width: 38px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.lazhu img {
  max-width: 100%;
  max-height: 100%;
}
.hua-left {
  position: absolute;
  left: 24%;
}
.hua-right {
  position: absolute;
  right: 24%;
}
.hua {
  bottom: 2px;
  max-width: 46px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.hua img {
  max-width: 100%;
  max-height: 100%;
}
.packgage-floor {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
}
.gift-floor {
  /* position: absolute; */
  bottom: 115px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 70px;
}
.gift-floor img {
  max-width: 35px;
}
.tabBarBottmon {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  height: 50px;
}
.tabBarBottmon > .item {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tabBarBottmon > .item > .icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.tabBarBottmon > .item > .text {
  font-size: 10px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.jibaiBtn {
  position: fixed;
  width: 74px;
  height: 74px;
  bottom: 10px;
  left: 50%;
  margin-left: -37px;
}
.jibaiBtn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 7s;
}
.fire-left{
  width: 50px;
    height: 100px;
    position: absolute;
    top: 244px;
  
}

.fire-right{
  width: 50px;
    height: 100px;
    position: absolute;
    right: 0;
    top: 244px;
  
}
</style>
